import { Injectable } from '@angular/core';
import { HttpClient,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs';
import { IPagedResults } from '../../../services/mocks/mock.interfaces';
import { LoggerService } from '../../../shared/services/logger.service';
import { environment } from '../../../../environments/environment';
import { Authority } from '../..//../models/authority.model';
import { Parent } from '../..//../models/parent.model';
import { Feature } from 'src/app/models/feature.model';

@Injectable({
  providedIn: 'root'
})
export class ParentService {

  constructor(private http: HttpClient,
              private logger: LoggerService) {
  }

  getParentListPage(page: number, size: number): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/parents?page='+page+'&size='+size);
  }
  getParentList(): Observable<any> {  
    return this.http.get<any>(environment.apiBase+'/parents/all');
  }
  addParent(parent: Parent): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/parents',parent);
  }
  getSubscribedFeatures(tenant: string): Observable<any> {  
      return this.http.get<any>(environment.companyBase+'/getSubscribedFeatures/'+tenant);
  }
  overrideSubscription(userName: string, featureList: Feature[]): Observable<any> {
    return this.http.post<any>(environment.apiBase+'/parents/overrideSubscription/'+userName,featureList);
  }

  getAcademicList(): Observable<any> {  
      return this.http.get<any>(environment.apiBase+'/sessions/academicList/3/2'); // Prev 3 years & next 2 years
  }
  getfeeList(admNumber: string, academicYear: string): Observable<any> {  
      return this.http.get<any>(environment.apiBase+'/fee/details/'+admNumber+'/'+academicYear);
  }


  /******************************************************************************************/
  getAuthorityListPage(page: number, size: number): Observable<any> {  
    return this.http.get<any>(environment.authBase+'/api/roles?page='+page+'&size='+size);
  }
  getAuthorityList(): Observable<any> {  
    return this.http.get<any>(environment.authBase+'/api/roles/all');
  }
  getAuthorityById(authorityId: number): Observable<Authority> {  
    return this.http.get<any>(environment.authBase+'/api/roles/'+authorityId);
  }
  addAuthority(authority: Authority): Observable<any> {
    return this.http.post<any>(environment.authBase+'/api/roles',authority);
  }  
  updateAuthority(authority: Authority): Observable<any> {
    return this.http.put<any>(environment.authBase+'/api/roles/update',authority);
  }
  deleteAuthorities(authorityList: Authority[]): Observable<any> { 
    console.log('deleteAuthorities>>> ',JSON.stringify(authorityList))
    return this.http.post<any>(environment.authBase+'/api/roles/delete',authorityList);
  }
}
